
export default [
  'unAuthedInterceptor',
  ResourceActions,
];

export function ResourceActions(unAuthedInterceptor) {
  return {
    'get': {
      method: 'GET',
      headers: resourceHeaders.get,
      interceptor: unAuthedInterceptor,
      timeout: 20000
    },
    'query': {
      method: 'GET',
      isArray: true,
      headers: resourceHeaders.get,
      interceptor: unAuthedInterceptor,
      timeout: 20000
    },
    'save':  {
      method: 'POST',
      headers: resourceHeaders.post,
      interceptor: unAuthedInterceptor,
      timeout: 20000
    },
    'update':  {
      method: 'PATCH',
      headers: resourceHeaders.patch,
      interceptor: unAuthedInterceptor,
      timeout: 20000
    },
    'delete': {
      method: 'DELETE',
      headers: resourceHeaders.get, // ??
      interceptor: unAuthedInterceptor,
      timeout: 20000
    }
  };
}

const postHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

const patchHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

const getHeaders = {
  'Accept': 'application/json'
};

export const resourceHeaders = {
  get: getHeaders,
  post: postHeaders,
  patch: patchHeaders,
};
